export default __webpack_public_path__ + "img/timeline-f15d86bd.png";